import '../styles/App.scss';
import Hero from './Hero';
import Goo from './Goo';
import Work from './Work';
import About from './About';
import Footer from './Footer';
import noise from "../img/noise.png";
import Fade from 'react-reveal/Fade';

function App() {
  return (
    <div className="App">
      <div id="background"></div>
      <div id="noise" style={{ backgroundImage: `url(${noise})` }}></div>
      <Goo />
      <Hero />
      <Fade><hr /></Fade>
      <Work />
      <Fade><hr /></Fade>
      <About />
      <Fade><hr /></Fade>
      <Footer />
    </div>
  );
}

export default App;
